export default {
    name: "users",
    component: () => import('@/layouts/PrincipalLayout.vue'),
    children: [
        {
            path: "",
            name: "users-index",
            meta: {
                requiresAdmin: true,
                breadcrumbs: [],
                title: "Usuarios"
            },
            component: () => import('@/modules/users/views/Index.vue')
        }
    ]
}
